module.exports = __webpack_public_path__ + "img/jordskokkesuppe_kog.459e811c.jpg";